// * POST
export const POST_TICKET_TRANSFER = 'index/POST_TICKET_TRANSFER';
export const EXECUTE_TICKET_TRANSFER = 'index/EXECUTE_TICKET_TRANSFER';
export const CANCEL_TICKET_TRANSFER = 'index/CANCEL_TICKET_TRANSFER';

// * Fetch
export const FETCH_EMPLOYEE_INSURANCE_COMPANIES_BY_RUT =
  'index/FETCH_EMPLOYEE_INSURANCE_COMPANIES_BY_RUT';
